export default __webpack_public_path__ + "static/media/CSS.b1c38e7b.png";